<template>
  <div class="ele-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="content">
        <div class="info">
          <div class="info-img">
            <img
              v-show="fileData.length > 0"
              :src="'data:image/jpg;base64,' + fileData"
            />
            <div class="info-img-none" v-show="fileData.length == 0">
              暂无图片
            </div>
          </div>
          <div class="info-content">
            <div class="info-name">{{ selectedMeasure.measureName }}</div>
            <div class="item">
              <div class="item-title">基本信息：</div>
              <div class="info-item-content magrin">
                <div
                  v-for="(item, index) in propertyData.propertyGroups"
                  :key="index"
                >
                  <div v-if="item.name.indexOf('BasicInformation') > -1">
                    <div style="display: flex; flex-flow: wrap">
                      <div
                        v-for="(obj, index) in item.properties"
                        :key="index + 'a'"
                        style="padding-right: 10px"
                        v-show="
                          obj.name !== 'shield' &&
                          obj.name !== 'isVirtual' &&
                          obj.name.indexOf('benchmarking') == -1
                        "
                      >
                        <label>{{ obj.displayName }}:</label>
                        <label>{{ obj.value }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="item-title">更新时间：</div>
              <div class="magrin">{{ wsData.time || "-" }}</div>
            </div>
            <div class="item">
              <div class="item-title">门禁状态：</div>
              <div
                class="magrin"
                :style="{
                  color: wsData.value == '关闭' ? '#4a99ea' : 'rgb(234 74 74)',
                }"
              >
                {{ wsData.value || "-" }}
              </div>
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="search">
            时段：
            <el-date-picker
              v-model="search.startTime"
              type="datetime"
              placeholder="开始时间"
            ></el-date-picker>
            <label style="padding: 0px 10px">-</label>
            <el-date-picker
              v-model="search.endTime"
              type="datetime"
              placeholder="结束时间"
            ></el-date-picker>
            <el-button
              style="margin-left: 10px"
              type="primary"
              @click="getTableData"
              >查询</el-button
            >
          </div>
          <div class="table">
            <nk-table
              :data="tableData"
              :columns="coulums"
              :border="false"
            ></nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import NkTable from "@/components/common/NkTable.vue";
import socket from "@/utils/websocket.js"; // 组件
import ResizeContainer from "@/components/common/resizeContainer.vue";
import api from "@common/api/index.js";
import dateTool from "@/utils/dateTool.js"; // 组件
import { findDataByParam } from "@/utils/index.js";
export default {
  components: {
    TabTree,
    BtnShow,
    NkTable,
    ResizeContainer,
  },
  data() {
    return {
      viewTreeData: [],
      tabShow: true,
      search: {
        startTime: new Date().setDate(new Date().getDate() - 1),
        endTime: new Date(),
      },
      selectedMeasure: {},
      fileData: "",
      propertyData: [],
      enumData: [],
      expression: {},
      webSock: {},
      socket: null,
      wsData: {},
      coulums: [],
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
  },
  methods: {
    init() {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          vm.$store.state.user.currentCompanyId,
          "/analysis/entranceGuard",
          null
        )
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          vm.viewTreeData = viewTreeData;
        });
    },
    tabTreeDefault(e) {
      let vm = this;
      vm.selectedMeasure = e;
      api.enumClass
        .getSubEnumClasses2("", 0, this.$store.state.user.currentCompanyId)
        .then((res) => {
          this.enumData = res.data;
          vm.getData();
        });
    },
    tabTreeClick(e) {
      let vm = this;
      if (vm.selectedMeasure.id !== e.id) {
        vm.selectedMeasure = e;
        vm.getData();
      }
    },
    getData() {
      let vm = this;
      vm.wsData = {};
      let apiArr = [
        api.measure.getMeasureAlbumCover(vm.selectedMeasure.measureId + ""),
        api.measure.getMeasuresProperties2(
          JSON.stringify([vm.selectedMeasure.measureId])
        ),
        api.measure.getUniqueMeasuresExpressions(
          JSON.stringify([vm.selectedMeasure.measureId])
        ),
      ];

      if (vm.socket) {
        vm.socket.close();
        vm.socket = null;
      }

      Promise.all(apiArr).then((resData) => {
        //获取封面图片
        if (resData[0].success) {
          vm.fileData = resData[0].data.fileInfo
            ? resData[0].data.fileInfo.fileData
            : "";
        }
        //获取参数
        if (resData[1].success) {
          for (
            let index = 0;
            index < resData[1].data[0].propertyGroups.length;
            index++
          ) {
            for (
              let j = 0;
              j < resData[1].data[0].propertyGroups[index].properties.length;
              j++
            ) {
              if (
                resData[1].data[0].propertyGroups[index].properties[j]
                  .regulation.valueType == 5
              ) {
                const item = this.enumData.find(
                  (c) =>
                    c.name ==
                    resData[1].data[0].propertyGroups[index].properties[j].value
                );
                if (item) {
                  resData[1].data[0].propertyGroups[index].properties[j].value =
                    item.displayName;
                }
              }
            }
          }

          vm.propertyData = resData[1].data[0];
        }

        vm.expression = null;
        //获取ws公式参数
        if (resData[2].success) {
          let bol = false;
          for (let i = 0; i < resData[2].data[0].expressionGroups.length; i++) {
            const element = resData[2].data[0].expressionGroups[i];
            for (let j = 0; j < element.expression.length; j++) {
              if (element.expression[j].name == "STATE") {
                vm.expression = element.expression[j];
                bol = true;
                break;
              }
            }
            if (bol) {
              break;
            }
          }
        }
        vm.getTableData();
        if (vm.expression) {
          //注册ws
          vm.getKey();
        }
      });
    },
    getKey() {
      let vm = this;
      api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        vm.webSock.ip = res.data.ip;
        vm.webSock.port = res.data.port;
        vm.webSock.key = res.data.key;
        vm.webSock.path = res.data.path;

        let agentData = {
          methodCode: "101",
          key: vm.webSock.key,
        };

        vm.socket = new socket({
          //网址（端口是我下面的服务器的端口）
          url:
            window.baseConfig.wsAgreement +
            "://" +
            res.data.ip +
            ":" +
            res.data.port +
            "/" +
            res.data.path,
        });

        vm.socket.onopen((event) => {
          vm.socket.send(agentData);
        });
        //接收信息
        vm.socket.onmessage((data) => {
          vm.webSockMsg(JSON.parse(data));
        });
      });
    },
    webSockMsg(e) {
      let vm = this;
      if (e.methodCode == "102") {
        vm.socket.send({
          methodCode: "103",
          measures: JSON.stringify([
            {
              id: vm.selectedMeasure.measureId,
              points: [
                {
                  code: vm.expression.pointCode,
                  number: vm.expression.pointNumber,
                },
              ],
            },
          ]),
        });
      } else if (e.methodCode == "104") {
      } else if (e.methodCode == "105") {
        if (e.data.length > 0) {
          vm.wsData = {
            time: e.data[0].time,
            value: e.data[0].data[0].value == 0 ? "关闭" : "打开",
          };
        }
      }
    },
    async getTableData() {
      let vm = this;
      let res = await api.doorControl.getDoorControlRecords(
        vm.selectedMeasure.measureId,
        "601",
        "0",
        dateTool.format(new Date(vm.search.startTime), "yyyy-MM-dd hh:mm:ss"),
        dateTool.format(new Date(vm.search.endTime), "yyyy-MM-dd hh:mm:ss"),
        0,
        1
      );
      if (res.success) {
        let coulums = [
          { prop: "time", label: "刷卡时间", show: true },
          { prop: "nickname", label: "名称", show: true },
          { prop: "authData", label: "验证数据", show: true },
          { prop: "authMethod", label: "验证方式", show: true },
          { prop: "action", label: "动作", show: true },
          { prop: "employeeNumber", label: "员工号", show: true },
        ];
        vm.coulums = coulums;
        for (let i = 0; i < res.data.length; i++) {
          let item = res.data[i];
          if (item.authMethod && item.authMethod != 0) {
            let authMethod = item.authMethod;
            switch (authMethod) {
              case 1:
                item.authMethod = "密码";
                break;
              case 2:
                item.authMethod = "IC卡";
                break;
              case 3:
                item.authMethod = "身份证";
                break;
              case 4:
                item.authMethod = "指纹";
                break;
              case 5:
                item.authMethod = "人脸识别";
                break;
            }
          } else {
            item.authMethod = "未知";
          }
          if (parseFloat(item.action) == 1) {
            item.action = "关闭";
          } else {
            item.action = "开启";
          }
          if (parseFloat(item.employeeNumber) == 0) {
            item.employeeNumber = "未知";
          }
          item.nickname =
            item.user && item.user.nickname ? item.user.nickname : "-";
        }
        vm.tableData = res.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/entranceGuard.scss";
.ele-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  width: 100%;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.info {
  height: 200px;
  background: #ffffff;
  overflow: hidden;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  .info-img {
    float: left;
    width: 200px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    .info-img-none {
      color: #cccccc;
      width: 100%;
      text-align: center;
      line-height: 160px;
      font-size: 26px;
      border: 1px solid #cccccc;
      height: 100%;
    }
  }
  .info-content {
    float: left;
    color: #000;
    width: calc(100% - 200px);
    .info-name {
      color: rgb(70, 144, 241);
      font-size: 16px;
      font-weight: bold;
      height: 30px;
      text-align: left;
      padding-left: 20px;
    }
    .item {
      min-height: 30px;
      display: flex;
      align-items: center;
      margin-left: 10px;
      border: 1px solid #cccccc;
      margin-top: -1px;
      .magrin {
        margin-left: 10px;
      }
      .item-title {
        width: 100px;
        text-align: right;
        padding-right: 10px;
        border-right: 1px solid #cccccc;
      }
      .info-item-content {
        width: calc(100% - 120px);
        white-space: break-spaces;
        text-align: left;
      }
    }
  }
}

.content-bottom {
  margin-top: 14px;
  height: calc(100% - 214px);
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;
  border-radius: 4px;
  .search {
    height: 40px;
    line-height: 40px;
    text-align: left;
    color: #000;
  }
  .table {
    margin-top: 10px;
    height: calc(100% - 50px);
  }
}
</style>